// extracted by mini-css-extract-plugin
export default {"header":"modal_header__C3wo3","main_section":"modal_main_section__4IWuO","model_button":"modal_model_button__A54a1"};